import {
	createSlice,
	createEntityAdapter,
	createSelector
} from '@reduxjs/toolkit';
import { selectAllStaff } from '../staff/staffSlice';

const departmentsAdapter = createEntityAdapter({});
const initialState = departmentsAdapter.getInitialState({});

const departmentsSlice = createSlice({
	name: 'departments',
	initialState,
	reducers: {
		setDepartments(state, action) {
			const departments = action.payload;
			departmentsAdapter.upsertMany(state, departments);
		}
	}
});

export const {
	selectAll: selectAllDepartments,
	selectById: selectDepartmentById,
	selectIds: selectDepartmentIds
} = departmentsAdapter.getSelectors((state) => state.departments);

export const { setDepartments } = departmentsSlice.actions;

// TODO: these departments are likely in the wrong order...
export const selectDeptsWithStaff = createSelector(
	[selectAllDepartments, selectAllStaff],
	(departments, staff) => {
		// Filter out inactive staff members
		const activeStaff = Object.values(staff).filter(
			(staffMember) => staffMember.status.toLowerCase() === 'active'
		);

		// Create a Set of unique department IDs from data in the staff slice for non-empty departments
		const staffDeptIds = new Set(
			Object.values(activeStaff).map(
				(staffMember) => staffMember.department
			)
		);

		// Filter departments to include only those with associated staff members
		const nonEmptyDepts = departments.filter((department) =>
			staffDeptIds.has(department.id)
		);
		return nonEmptyDepts;
	}
);

export default departmentsSlice.reducer;
